<template>
<div id="activity-app" class="container">
    <error-cant-reach-server :errorData="errorData" class="mt-4" v-if="isCantReach" @clickCTA="$reloadPage()"></error-cant-reach-server>
    <template v-for="activity in activities">
      <SimpleActivity
        v-if="activityTypes[activity.type] && activityTypes[activity.type].use === 'SIMPLE'"
        :key="activity.activityDetail.requestId"
        :activity="activity"
        :text="activityTypes[activity.type].text"
        >
      </SimpleActivity>
      <WithContractPhoto
        v-if="activityTypes[activity.type] && activityTypes[activity.type].use === 'WITH_PHOTO'"
        :key="activity.activityDetail.requestId"
        :activity="activity"
        :text="activityTypes[activity.type].text"
        >
      </WithContractPhoto>
      <ToPayButtonActivity
        v-if="activityTypes[activity.type] && activityTypes[activity.type].use === 'TOPAYBUTTON'"
        :key="activity.activityDetail.requestId"
        :activity="activity"
        :text="activityTypes[activity.type].text"
        >
      </ToPayButtonActivity>
      <ToContractButtonActivity
        v-if="activityTypes[activity.type] && activityTypes[activity.type].use === 'TOCONTRACTBUTTON'"
        :key="activity.activityDetail.requestId"
        :activity="activity"
        :text="activityTypes[activity.type].text"
        >
      </ToContractButtonActivity>
      <ToStatementButtonActivity
        v-if="activityTypes[activity.type] && activityTypes[activity.type].use === 'TOSTATEMENTBUTTON'"
        :key="activity.activityDetail.requestId"
        :activity="activity"
        :text="activityTypes[activity.type].text"
        >
      </ToStatementButtonActivity>
      <!--
      <ReceiveContractRequestMoney
        v-if="activity.type === 'RECEIVE_CONTRACT_REQUEST_MONEY'"
        :key="activity.activityDetail.requestId"
        :activity="activity">
      </ReceiveContractRequestMoney>
      <ReceiveContractRequestThing
        v-if="activity.type === 'RECEIVE_CONTRACT_REQUEST_THING'"
        :key="activity.activityDetail.requestId"
        :activity="activity">
      </ReceiveContractRequestThing>
      <ApproveContractRequestMoney
        :key="activity.activityDetail.requestId"
        v-if="activity.type === 'APPROVE_CONTRACT_REQUEST_MONEY'"
        :activity="activity">
      </ApproveContractRequestMoney>
      -->
    </template>
</div>
</template>

<script>
// import ReceiveContractRequestMoney from './types/ReceiveContractRequestMoney'
// import ReceiveContractRequestThing from './types/ReceiveContractRequestThing'

// import ApproveContractRequestMoney from './types/ApproveContractRequestMoney'

import SimpleActivity from './types/SimpleActivity'
import WithContractPhoto from './types/WithContractPhoto'
import ToPayButtonActivity from './types/ToPayButtonActivity'
import ToContractButtonActivity from './types/ToContractButtonActivity'
import ToStatementButtonActivity from './types/ToStatementButtonActivity'

// WITH_PHOTO's text -> insert next to 'from' name
// SIMPLE's text -> plain ol' notification

export default {
  data: () => ({
    isCantReach: false,
errorData: {},
    activities: [],
    activityTypes: {
      'RECEIVE_CONTRACT_REQUEST_MONEY': { use: 'WITH_PHOTO', text: 'ส่งคำขอกู้เงิน' },
      'RECEIVE_CONTRACT_REQUEST_THING': { use: 'WITH_PHOTO', text: 'ส่งคำขอซื้อขาย' },
      'RECEIVE_CONTRACT_REQUEST_MORTGAGE': { use: 'WITH_PHOTO', text: 'ส่งคำขอสินเชื่อบ้าน' },
      'RECEIVE_CONTRACT_POSTPONE': { use: 'WITH_PHOTO', text: 'ส่งคำขอผ่อนผันสัญญา' },
      'RECEIVE_CONTRACT_CANCEL': { use: 'WITH_PHOTO', text: 'ส่งคำขอยกเลิกสัญญา' },

      'APPROVE_CONTRACT_REQUEST_MONEY': { use: 'SIMPLE', text: 'อนุมัติสัญญาเงินกู้' },
      'APPROVE_CONTRACT_REQUEST_THING': { use: 'SIMPLE', text: 'อนุมัติสัญญาซื้อขาย' },
      'APPROVE_CONTRACT_REQUEST_MORTGAGE': { use: 'SIMPLE', text: 'อนุมัติสัญญาสินเชื่อบ้าน' },
      'APRROVE_CONTRACT_REQUEST_POSTPONE': { use: 'SIMPLE', text: 'สัญญาได้รับการผ่อนผัน' },
      'APRROVE_CONTRACT_REQUEST_CANCEL': { use: 'SIMPLE', text: 'สัญญาถูกยกเลิก' },

      'DISPUTE_CONTRACT_REQUEST_MONEY': { use: 'WITH_PHOTO', text: 'ส่งคำขอกู้เงินที่ถูกแก้ไขมา' },
      'DISPUTE_CONTRACT_REQUEST_THING': { use: 'WITH_PHOTO', text: 'ส่งคำขอซื้อขายที่ถูกแก้ไขมา' },
      'DISPUTE_CONTRACT_REQUEST_MORTGAGE': { use: 'WITH_PHOTO', text: 'ส่งคำขอสินเชื่อบ้านที่ถูกแก้ไขมา' },

      'CONTRACT_CREATE_CHILD_MONEY': { use: 'TOCONTRACTBUTTON', text: 'ปรับสัญญาเงินกู้ปรับสัญญาใหม่' },
      'CONTRACT_CREATE_CHILD_THING': { use: 'TOCONTRACTBUTTON', text: 'ปรับสัญญาซื้อขายปรับสัญญาใหม่' },
      'CONTRACT_CREATE_CHILD_MORTGAGE': { use: 'TOCONTRACTBUTTON', text: 'ปรับสัญญาสินเชื่อบ้านปรับสัญญาใหม่' },

      'CONTRACT_EXEMPT_REQUEST_MORTGAGE': { use: 'TOCONTRACTBUTTON', text: 'ปรับสัญญาสินเชื่อบ้านผ่อนผัน' },
      'CONTRACT_EXEMPT_CANCEL_MORTGAGE': { use: 'TOCONTRACTBUTTON', text: 'ปรับสัญญาสินเชื่อบ้านยกเลิกการผ่อนผัน' },

      'REJECT_CONTRACT_REQUEST_CANCEL': { use: 'SIMPLE', text: 'ไม่อนุมัติคำขอ' },

      'REJECT_CONTRACT_REQUEST_MONEY': { use: 'SIMPLE', text: 'ไม่อนุมัติคำขอกู้เงิน' },
      'REJECT_CONTRACT_REQUEST_THING': { use: 'SIMPLE', text: 'ไม่อนุมัติคำขอซื้อขาย' },
      'REJECT_CONTRACT_REQUEST_MORTGAGE': { use: 'SIMPLE', text: 'ไม่อนุมัติคำขอสินเชื่อบ้าน' },

      'RECEIVE_CONTRACT_DUE_DATE': { use: 'SIMPLE', text: 'ถึงเวลาชำระงวด' },

      'RECEIVE_INVOICE_PAY': { use: 'TOSTATEMENTBUTTON', text: 'ได้รับเงินค่างวด' },
      'PAY_INVOICE': { use: 'SIMPLE', text: 'ได้จ่ายเงินค่างวด' },

      // UNKNOWN SIDE / Might be both
      // ยอมรับ dispute และเริ่มสัญญา
      'APPROVE_CONTRACT_DISPUTE_MONEY': { use: 'SIMPLE', text: 'การแก้ไขสัญญาเงินกู้ถูกยอมรับและเริ่มต้นสัญญา' },
      'APPROVE_CONTRACT_DISPUTE_THING': { use: 'SIMPLE', text: 'การแก้ไขสัญญาซื้อขายถูกยอมรับและเริ่มต้นสัญญา' },
      'APPROVE_CONTRACT_DISPUTE_MORTGAGE': { use: 'SIMPLE', text: 'การแก้ไขสัญญาสินเชื่อบ้านถูกยอมรับและเริ่มต้นสัญญา' },

      // ไม่ยอมรับ จบ...
      'REJECT_CONTRACT_DISPUTE_MONEY': { use: 'SIMPLE', text: 'การแก้ไขสัญญาเงินกู้ถูกปฏิเสธ' },
      'REJECT_CONTRACT_DISPUTE_THING': { use: 'SIMPLE', text: 'การแก้ไขสัญญาซื้อขายถูกปฏิเสธ' },
      'REJECT_CONTRACT_DISPUTE_MORTGAGE': { use: 'SIMPLE', text: 'การแก้ไขสัญญาสินเชื่อบ้านถูกปฏิเสธ' },

      'APPROVED_DEPOSIT': { use: 'TOSTATEMENTBUTTON', text: 'Goobank อนุมัติเงินฝากของคุณ จาก ระบบ Goobank' },
      'REJECTED_DEPOSIT': { use: 'SIMPLE', text: 'ปฏิเสธฝากเงิน' },
      'APPROVED_WITHDRAW': { use: 'TOSTATEMENTBUTTON', text: 'Goobank อนุมัติการถอนเงินของคุณ จาก ระบบ Goobank' },
      'REJECTED_WITHDRAW': { use: 'SIMPLE', text: 'ปฏิเสธถอนเงิน' },

      'RECEIVE_CONTRACT_DUE_DATE': { use: 'TOPAYBUTTON', text: 'ถึงวันจ่ายงวด ของสัญญา' },
      'RECEIVE_CONTRACT_END': { use: 'TOCONTRACTBUTTON', text: 'จ่ายงวดครบเรียบร้อย' },


    }
  }),
  async created () {
    try {
      const result = await this.$api.activity.list()
      const data = result.data
      if (!data.success) {
        this.isCantReach = true
this.errorData = data
        return
      }
      this.activities = data.activities
      // this.activities.push({
      //   activityDetail: {
      //     contractId: 7,
      //     contractNo: "M19000005",
      //     from: {
      //       avatarPath: "https://goobank.test/goobank_assets/common/img/avatar.png",
      //       id: 1,
      //       memberType: "korgoo",
      //       name: "ตาหวาน"
      //     },
      //     moneyPayload: {
      //       amount: "900.00",
      //       duration: 1,
      //       interest: "0.15"
      //     },
      //   },
      //   datetime: new Date(),
      //   type: 'RECEIVE_CONTRACT_END'
      // })
      setNotificationBadge(false)
    } catch (e) {
      console.error(e)
    }
  },
  components: {
    SimpleActivity,
    WithContractPhoto,
    ToPayButtonActivity,
    ToContractButtonActivity,
    ToStatementButtonActivity
  }
}
</script>

<style lang="scss">
</style>
